import api from "./api"

export const getSupplierInvoiceFormData = async () => {
  const response = await api.get("/supplier-invoices/form-data")
  return response.data
}

export const getSupplierInvoices = async (params = {}) => {
  const response = await api.get("/supplier-invoices", {
    params,
  })

  return response.data
}

export const getSupplierInvoiceById = async (invoiceId) => {
  const response = await api.get(
    `/supplier-invoices/${invoiceId}`
  )

  return response.data
}

export const createSupplierInvoice = async (payload) => {
  const response = await api.post(
    "/supplier-invoices",
    payload
  )

  return response.data
}

export const validateSupplierInvoice = async (
  invoiceId,
  payload = {}
) => {
  const response = await api.post(
    `/supplier-invoices/${invoiceId}/validate`,
    payload
  )

  return response.data
}